var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart-scatter"}},[_c('apexchart',{attrs:{"height":_vm.height || 350,"options":_vm.chartOptions,"series":_vm.series,"type":"scatter","width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }